import React from 'react';
import {TextField} from "./inputs/TextField/TextField";
import {FullNameField} from "./inputs/FullNameField/FullNameField";
import {NumberField} from "./inputs/NumberField/NumberField";
import {AutocompleteSelect} from "./selects/AutocompleteSelect/AutocompleteSelect";
import {BaseSelect} from "./selects/BaseSelect/BaseSelect";
import {DateTimeSelect} from "./selects/DateTimeSelect/DateTimeSelect";
import {NormativeArticlesTable} from "./tables/NormativeArticlesTable/NormativeArticlesTable";
import {DragAndDropFilesUpload} from "./uploads/DragAndDropFilesUpload/DragAndDropFilesUpload";
import {SelectedOffenseList} from "./tables/SelectedOffenseList/SelectedOffenseList";
import {NormativeArticleSelect} from "./selects/NormativeArticleSelect/NormativeArticleSelect";
import {DynamicFields} from "../../utils/dynamicFields";
import {MultilineTextField} from "./inputs/MultilineTextField/MultilineTextField";
import {FreeAutocompleteSelect} from "./selects/FreeAutocompleteSelect/FreeAutocompleteSelect";
import { ContractorViolationsTable } from './tables/ContractorViolationsTable/ContractorViolationsTable';
import { DragAndDropActUpload } from './uploads/DragAndDropFilesUpload/DragAndDropActUpload';
import { AnalysisUpload } from './uploads/DragAndDropFilesUpload/AnalysisUpload';
import { ChipBlock } from './blocks/ChipBlock/ChipBlock';
import { CheckboxField } from './checkbox/CheckboxField/CheckboxField';
import Signature from './uploads/Signature/Signature';
import QrCode from './uploads/qr_code/qrCode';
import QrCodeViolation from './uploads/qr_code/qrCodeViolation';
import { CheckList } from './tables/checkList/checkList';
import { TableConstructorField } from '../TableConstructorField/TableConstructorField/TableConstructorField';
import { SignatureForTable } from './uploads/Signature/SignatureForTable';
import { ChartFieldConstructorUser } from '../ChartFieldConstructor/ChartFieldConstructorUser/ChartFieldConstructorUser';
import { MultilineTextFieldTable } from '../TableConstructorField/TableConstructorField/TableField/MultilineTextFieldTable';


export const DynamicFieldComponent = React.memo( ({type, ...props}) => {
    switch (type) {
        case DynamicFields.TEXT_FIELD:
            return <TextField {...props}/>
        case DynamicFields.MULTILINE_TEXT_FIELD:
            return <MultilineTextField {...props}/>
        case DynamicFields.FULL_NAME_FIELD:
            return <FullNameField {...props}/>
        case DynamicFields.NUMBER_FIELD:
            return <NumberField {...props}/>
        case DynamicFields.AUTOCOMPLETE_SELECT:
            return <AutocompleteSelect {...props}/>
        case DynamicFields.FREE_AUTOCOMPLETE_SELECT:
            return <FreeAutocompleteSelect {...props}/>
        case DynamicFields.BASE_SELECT:
            return <BaseSelect {...props}/>
        case DynamicFields.DATE_TIME_SELECT:
            return <DateTimeSelect {...props}/>
        case DynamicFields.REMOVAL_DATE_TIME:
            return <DateTimeSelect {...props}/>
        case DynamicFields.CHECKBOX_FIELD:
            return <CheckboxField {...props}/>
        case DynamicFields.CHIP_BLOCK:
            return <ChipBlock {...props}/>
        case DynamicFields.NORMATIVE_ARTICLE_SELECT:
            return <NormativeArticleSelect {...props}/>
        case DynamicFields.NORMATIVE_ARTICLES_TABLE:
            return <NormativeArticlesTable {...props}/>
        case DynamicFields.CONTRACTOR_VIOLATIONS_TABLE:
            return <ContractorViolationsTable {...props}/>
        case DynamicFields.DRAG_AND_DROP_FILES_UPLOAD:
            return <DragAndDropFilesUpload {...props}/>
        case DynamicFields.DRAG_AND_DROP_ACT_UPLOAD:
            return <DragAndDropActUpload {...props}/>
        case DynamicFields.UPLOAD_ANALYSIS:
            return <AnalysisUpload {...props}/>
        case DynamicFields.SELECTED_OFFENSE_LIST:
            return <SelectedOffenseList {...props}/>
        case DynamicFields.SIGNATURE_FIELD:
            return <Signature {...props}/>
        case DynamicFields.QR_CODE_FIELD:
            return <QrCode {...props} />
        case DynamicFields.QR_CODE_VIOLATION:
            return <QrCodeViolation {...props} />  
        case DynamicFields.CHECK_LIST:
            return <CheckList {...props} />    
        case DynamicFields.TABLE_CONSTRUCTOR:
            return  <TableConstructorField {...props} />  
        case DynamicFields.SIGNATURE_FOR_TABLE:
            return  <SignatureForTable {...props} />
        case DynamicFields.CHART_CONSTRUCTOR:
            return  <ChartFieldConstructorUser {...props} />
        case DynamicFields.TABLE_MULTILINE:
            return  <MultilineTextFieldTable {...props} />
        default:
            return null
    }
})